import React from "react";
import * as moment from "moment";

export function DateColumn({ value, griddleKey, data }) {
  if (value === undefined || value === null) {
    return <div>{value}</div>;
  }

  let dateStr = value.replace(/\s+/g, " ");
  const mdate = moment.utc(dateStr); //.format("MMM D YYYY h:mmA");

  return (
    <div>{mdate.isValid() ? mdate.format("MM-DD-YYYY hh:mm A") : dateStr}</div>
  );
}

export function DateOnlyColumn({ value, griddleKey, data }) {
  if (value === undefined || value === null) {
    return <div>{value}</div>;
  }

  let dateStr = value.replace(/\s+/g, " ");
  const mdate = moment.utc(dateStr); //.format("MMM D YYYY h:mmA");

  return <div>{mdate.isValid() ? mdate.format("MM-DD-YYYY") : dateStr}</div>;
}



// WEBPACK FOOTER //
// ./src/components/Table/TableRows.jsx